/**
 * @typedef {Object} searchCriteriaList
 * @prop {string} filterInput
 * @prop {array<string | number>} searchTarget
 * @prop {string} ipcCode
 */

/**
 * @typedef {Object} searchCriteriaAction
 * @prop {('ADD_SEARCH_CRITERIA'|'DELETE_SEARCH_CRITERIA')} type
 * @prop {string} filterInput
 * @prop {array<string | number>} searchTarget
 * @prop {string} ipcCode
 */

const initialState = {}

/**
 * 受け取ったtypeをもとに登録する情報を返す
 * @param {searchCriteriaList} state
 * @param {searchCriteriaAction} actions
 * @returns {searchCriteriaList}
 */
export const searchCriteria = (state = initialState, actions) => {
    switch (actions.type) {
        case 'ADD_SEARCH_CRITERIA':
            return {
                ...state,
                filterInput: actions.filterInput,
                searchTarget: actions.searchTarget,
                ipcCode: actions.ipcCode
            }
        case 'DELETE_SEARCH_CRITERIA':
            return initialState
        default:
            return state
    }
}
